/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import LoginModal from "../../components/LoginModal";
import {useAuth} from "../../Hooks/useAuth";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import Loader from "../../elements/loader";
import {useTranslation} from "react-i18next";

const PartRequest = (props) => {

    const { t, i18n } = useTranslation();

    const axiosJWT = useAxiosJTW();
    const user = useAuth();

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [disabledButton, setDisabledButton] = useState(false);
    const [requestStatus, setRequestStatus] = useState(0); //1: success, 2: error, 3: loader

    const sendpartemailrequest = () => {

        setRequestStatus(3);
        axiosJWT.post('api/sendpartemailrequest', {parts: [props.parts], user_id: user.profile.user_id, ads_id: props.ads_id, merchant_email: props.merchant_email, code: props.code}).then( (response) => {

            if(response.status === 200){
                setRequestStatus(1);
                setDisabledButton(true);
            }else{
                setRequestStatus(2);
            }
        }).catch( (error) => {
            setRequestStatus(2);
        } );
    }

    const submitRequest = () => {
        sendpartemailrequest();
    }

    return (
        <>
            {/*<RequestModal/>*/}
            <div className='pt-4'>
                {user.profile.isLogged
                    ? <button className='btn btn-primary btn-parts-request' disabled={disabledButton} onClick={submitRequest}>{t('parts.sendreqpart')}</button>
                    : <LoginModal showModal={showLoginModal} buttonText={t('parts.sendreqpart')} />
                }

            </div>
            <div className='pt-4'>
                { requestStatus == 3 && <div className='small' style={{ textAlign : 'center', margin: '0 auto' }}><Loader/></div> }
                { requestStatus == 1 && <div className="alert alert-success text-center" role="alert">{t('parts.reqdend')}</div>}
                { requestStatus == 2 && <div className="alert alert-danger text-center" role="alert">{t('parts.reqerror')}</div>}
            </div>

        </>
    );
};

export default PartRequest;
